const text = {
	allProjects: {
		fr: "Tous mes projets",
		en: "All projects",
	},
	products: {
		fr: "Livrable :",
		en: "Deliverable:",
	},
	products2: {
		fr: "Livrables",
		en: "Deliverable",
	},
	role: {
		fr: "Rôle",
		en: "Role",
	},
	industry: {
		fr: "Secteur d'activité :",
		en: "Industry:",
	},
	otherProjects: {
		fr: "Autres projets",
		en: "Other projects",
	},
	viewWebsite: {
		fr: "Voir le site",
		en: "Go to website",
	},
	photoCredit: {
		fr: "Crédits photo",
		en: "Photo credits",
	},
	date: {
		fr: "Date",
		en: "Date",
	},
	other: {
		fr: "autres",
		en: "more",
	},
	work: {
		fr: "projets",
		en: "work",
	},
	contactLabel: {
		fr: "Contactez-moi",
		en: "Contact me",
	},
	footerLegals: {
		fr: "© 2025 Tous droits réservés.",
		en: "2025 All rights reserved.",
	},
	footerLegals2: {
		fr: "Design & Code par P.Factory.",
		en: "Design & Code by P.Factory.",
	},
	footerLegalLabel: {
		fr: "Mentions légales",
		en: "Legal information",
	},
	email: {
		fr: "Email :",
		en: "Email:",
	},
	vat: {
		fr: "Numéro de TVA intracommunautaire :",
		en: "VAT number:",
	},
	siren: {
		fr: "SIREN :",
		en: "SIREN number:",
	},
	adress: {
		fr: "Adresse :",
		en: "Address:",
	},
	phone: {
		fr: "Téléphone :",
		en: "Phone:",
	},
	featured: {
		fr: "En vedette",
		en: "Featured",
	},
	nav: {
		work: { fr: "Projets", en: "Work" },
		services: { fr: "Services", en: "Services" },
		about: { fr: "À propos", en: "About" },
		contact: { fr: "Contact", en: "Contact" },
		play: { fr: "Jouer", en: "Play" },
	},
	footerText1: {
		fr: "Vous avez un",
		en: "Do you have an",
	},
	footerText2: {
		fr: "super projet ?",
		en: "awesome project?",
	},
	footerText3: {
		fr: "C’est le moment idéal pour se lancer !",
		en: "It's the perfect time to get started!",
	},
	legalPage: {
		title: {
			fr: "Mentions",
			en: "Legal",
		},
		title2: {
			fr: "Légales",
			en: "Notice",
		},
		publisher: {
			fr: "Éditeur du site",
			en: "Publisher",
		},
		publisherText: {
			fr: "Paul Demellier – P.Factory\nSIREN : 751 834 938\nNuméro de TVA intracommunautaire : FR07751834938\nAdresse : 15 rue des États, 44000 Nantes\nTéléphone. : 07 87 42 60 88\nEmail : paul.demellier@paul-factory.com",
			en: "Paul Demellier – P.Factory\nSIREN: 751 834 938\nVAT ID: FR07751834938\nAddress: 15 rue des États, 44000 Nantes, France\nPhone: +33 7 87 42 60 88\nEmail: paul.demellier@paul-factory.com",
		},
		host: {
			fr: "Hébergement",
			en: "Hosting",
		},
		hostText: {
			fr: "OVH, 2 rue Kellermann, 59100 Roubaix.",
			en: "OVH, 2 rue Kellermann, 59100 Roubaix, France.",
		},
		publication: {
			fr: "Responsable de la publication",
			en: "Publication Director",
		},
		publicationText: {
			fr: "Paul Demellier",
			en: "Paul Demellier",
		},
		property: {
			fr: "Propriété intellectuelle",
			en: "Intellectual Property",
		},
		propertyText: {
			fr: "Les contenus de ce site (textes, images, vidéos, graphismes, logo…) sont la propriété exclusive de P.Factory, sauf mention contraire. Toute reproduction ou utilisation sans autorisation est interdite.",
			en: "The content of this website (texts, images, videos, graphics, logo…) is the exclusive property of P.Factory, unless otherwise stated. Any reproduction or use without permission is prohibited.",
		},
		cookies: {
			fr: "Cookies & données personnelles",
			en: "Cookies & Personal Data",
		},
		cookiesText: {
			fr: "Ce site ne collecte pas de données personnelles à l’insu de l’utilisateur. Des cookies peuvent être utilisés à des fins statistiques ou de bon fonctionnement.",
			en: "This website does not collect personal data without the user's knowledge. Cookies may be used for statistics or proper functioning.",
		},
	},
	about: {
		intro1: {
			fr: "Moi c’est Paul, créatif passionné et adorateur des design systems bien organisés. Avec 13 ans d'expérience en direction artistique, UI/UX design et illustration, je suis spécialisé dans la conception d'identités visuelles de haute qualité, interfaces, produits web et design systems évolutifs. Egalement développeur front (HTML/CSS/JS), j’anticipe les contraintes techniques pour concevoir des projets réalistes, de la maquette à l'intégration.",
			en: "My name is Paul, a passionate creative and a fan of well-organized design systems. With 13 years of experience in Art Direction, UI/UX Design and Illustration, I specialize in crafting stunning visual identities, interfaces, web products, and scalable design systems. As a front-end developer (HTML/CSS/JS), I anticipate technical constraints to design realistic projects, from mock-ups to integration.",
		},
		intro2: {
			fr: "J’ai livré 50+ projets de A à Z dans des domaines très variés comme l’immobilier, la santé, le jeu vidéo, l’hôtellerie-restauration ou encore l’ingénierie.",
			en: "I have delivered 50+ projects from start to finish in a wide variety of fields, including real estate, healthcare, video games, hospitality, and engineering.",
		},
		intro3: {
			fr: "Fan de jeu vidéo et pop culture et synthwave, je conçois et développe également mes propres jeux mobiles sur Unity et Godot.",
			en: "I'm also a big fan of video games, pop culture and synthwave, and I design and develop my own mobile games using Unity and Godot.",
		},
		title1: { fr: "Paul, 34 ans", en: "Paul, 34 years old" },
		title2: { fr: "directeur artistique senior", en: "senior art director" },
		toolsTitle1: { fr: "Boite à", en: "" },
		toolsTitle2: { fr: "outils", en: "Toolbox" },
		toolsText: {
			fr: "Pour passer d’une idée à un projet concret, je m’appuie sur mes domaines de prédilection tout en explorant sans cesse de nouveaux terrains de jeu avec un max de curiosité.",
			en: "In order to turn an idea into a concrete project, I draw on my areas of expertise, all the while exploring new fields with boundless curiosity.",
		},
		cat1: { fr: "Design", en: "Design" },
		cat2: { fr: "Développement", en: "Development" },
		cat3: { fr: "3D & Gaming", en: "3D & Gaming" },
		cat4: { fr: "Extras", en: "Bonus" },
		cta: { fr: "Voir mes projets", en: "See my work" },
		rotatingTitles: {
			fr: ["directeur artistique", "digital designer", "illustrateur", "adorateur de café", "bricoleur du dimanche", "et vous ?"],
			en: ["art director", "digital designer", "illustrator", "coffee lover", "DIY enthusiast", "and you?"],
		},
		cv: {
			fr: "Mon CV",
			en: "Resume",
		},
	},
	home: {
		intro: {
			fr: "Ravi de vous rencontrer, moi c’est Paul, directeur artistique, UI/UX designer & illustrateur senior.",
			en: "Pleased to meet you, I'm Paul, senior Art Director, UI/UX Designer & illustrator.",
		},
		need: {
			fr: "Besoin",
			en: "You need",
		},
		rotatingTitles: {
			fr: ["d'une interface SaaS", "d'un site internet ?", "d'un logo ?", "d'un dépliant ?", "d'une newsletter ?", "d'une illustration ?", "d'une brochure ?", "de tout en même temps ?", "d'appuyer encore une fois ?", "d'amour ?", "de toi ?", "de moi ?", "de nous ?", "de repartir de zéro ?"],
			en: ["a SaaS interface", "a website?", "a logo?", "a flyer?", "a newsletter?", "an illustration?", "a brochure?", "everything at once?", "to click again?", "some love?", "you?", "me?", "us?", "to start over?"],
		},
		p1: {
			fr: "Avec 13 ans d’expérience dans la création web et print, j’ai pu développer une large palette de services pour répondre à vos projets les plus fous.",
			en: "With 13 years of experience in web and print creation, I’ve developed a wide range of services to meet even your wildest project ideas.",
		},
		p2: {
			fr: "J’ai le souci du détail et une rigueur à toute épreuve, et ce quelle que soit l’ampleur du projet. Parce qu’une marque forte est une des clés du succès sur le trousseau de la réussite, comptez sur moi pour être à l’écoute et vous apporter une expertise pointue.",
			en: "I am detail-oriented and extremely thorough, no matter how big the project is. Because a powerful brand identity is one of many keys to success, you can count on me to listen carefully and offer you cutting-edge expertise.",
		},
		btn1: {
			fr: "Voir tous mes services",
			en: "See all my services",
		},
		featured: {
			fr: "mis en avant",
			en: "featured",
		},
		testimonials: {
			fr: "Des clients",
			en: "Very satisfied",
		},
		testimonials2: {
			fr: "très satisfaits",
			en: "customers",
		},
		testimoniallink: {
			fr: "Voir le projet associé",
			en: "See the related project",
		},
		number1: {
			fr: "projets accomplis",
			en: "projects completed",
		},
		number2: {
			fr: "années d'expérience",
			en: "years of experience",
		},
	},
	workpage: {
		client: {
			fr: "clients",
			en: "clients",
		},
		intro: {
			fr: "Retrouvez ici les plus gros projets sur lesquels j’ai travaillé ces dernières années, le tout bien rangé.",
			en: "Here you will find the biggest projects I have worked on in recent years, all neatly organized.",
		},
		all: {
			fr: "Tous",
			en: "All",
		},
	},
	services: {
		title1: {
			fr: "à votre",
			en: "At your",
		},
		title2: {
			fr: "service",
			en: "service",
		},
		intro: {
			fr: "Véritable couteau suisse, j’accompagne les entreprises pour créer et développer leur marque en proposant une vision artistique complète grâce à une large gamme d’expertises.",
			en: "Like a true Swiss Army knife, I help companies develop their brand by offering a complete artistic vision and a wide range of expertise.",
		},
	},
	contact: {
		title1: {
			fr: "Full",
			en: "Full",
		},
		title2: {
			fr: "contact",
			en: "contact",
		},
		intro: {
			fr: "Envie de parler des choses sérieuses ? C'est ici que ça se passe. Lancez-vous et décrivez-moi votre besoin créatif dans les grandes lignes, je ne manquerai pas de le lire avec la plus grande attention.",
			en: "This is where we get down to business. Go ahead and describe your creative needs in broad terms, and I'll be sure to read it carefully.",
		},
		greeting: {
			fr: "Paul, j'ai un super projet dont je veux te parler.",
			en: "Paul, I have an awesome project I want to talk to you about.",
		},
		name: {
			fr: "Prénom",
			en: "Name",
		},
		email: {
			fr: "E-mail",
			en: "E-mail",
		},
		phone: {
			fr: "Téléphone",
			en: "Phone",
		},
		message: {
			fr: "Votre plus beau message",
			en: "Your finest message",
		},
		alt: {
			fr: "Vous pouvez aussi me contacter directement :",
			en: "You can also contact me directly:",
		},
		messageSuccess1: {
			fr: "Perfecto !",
			en: "Magnifico!",
		},
		messageSuccess2: {
			fr: "Votre message a super bien été envoyé.",
			en: "Your message was very well sent.",
		},
		rgpd: {
			fr: "J’accepte que les informations saisies soient utilisées uniquement pour me contacter (et rien d'autre).",
			en: "I agree that the informations entered will be used only to contact me (and nothing else).",
		},
	},
	notfound: {
		title: {
			fr: "404",
			en: "404",
		},
		text: {
			fr: "page non trouvée",
			en: "page not found.",
		},
		back: {
			fr: "Retour à l’accueil",
			en: "Back to home",
		},
	},
	giftWheel: {
		trigger: {
			fr: "Ne pas cliquer ici",
			en: "Don't click here",
		},
		title: {
			fr: "Personne n'était censé voir ce jeu...",
			en: "You weren't supposed to see this game...",
		},
		description: {
			fr: "C'est LE secret pour gagner le pactole, et tout ça sans efforts. Tournez la roue et tentez de gagner jusqu'à 4000 €!",
			en: "This is THE secret to win big without effort. Spin the wheel and try to win up to €4000!",
		},
		close: {
			fr: "Fermer",
			en: "Close",
		},
		lose: {
			fr: "Perdu !",
			en: "You lost!",
		},
		result: {
			fr: "0 €",
			en: "€0",
		},
		power: {
			fr: "Puissance",
			en: "Power",
		},
		spinButton: {
			fr: "Tourner la roue",
			en: "Spin the wheel",
		},
		spinning: {
			fr: "Ça tourne…",
			en: "Spinning…",
		},
		messages: {
			fr: ["Dommage, c'étais pas loin.", "Ça sera pas pour cette fois.", "C'est la faute à pas de chance comme on dit.", "La richesse c'est pas pour tout de suite.", "La prochaine c'est la bonne, je le sens !"],
			en: ["Too bad, you were close.", "Not this time.", "Just bad luck, as they say.", "You won't be rich right away.", "Next one's the winner, I can feel it!"],
		},
		ariaLabels: {
			wheelSpinning: {
				fr: "La roue tourne",
				en: "The wheel is spinning",
			},
			chargePower: {
				fr: "Maintiens pour charger, relâche pour lancer",
				en: "Hold to charge, release to spin",
			},
			chargePercent: {
				fr: "Charge",
				en: "Charge",
			},
		},
	},
	cv: {
		intro: {
			fr: "Créatif passionné et adorateur des design systems bien organisés. Avec 13 ans d'expérience en direction artistique, UI/UX design et illustration, je suis spécialisé dans la conception d'identités visuelles de haute qualité, interfaces, produits web et design systems évolutifs. J’ai livré 50+ projets de A à Z dans des domaines très variés comme l’immobilier, la santé, le jeu vidéo, l’hôtellerie-restauration ou encore l’ingénierie.",
			en: "Creative professional specializing in well-organized design systems. With 13 years of experience in Art Direction, UI/UX Design and Illustration, I specialize in crafting stunning visual identities, interfaces, web products, and scalable design systems. I have delivered 50+ projects from start to finish in a wide variety of fields, including real estate, healthcare, video games, hospitality, and engineering.",
		},
		website: {
			fr: "Portfolio",
			en: "Portfolio",
		},
		permis: {
			fr: "Permis B",
			en: "Driving license",
		},
		toolbox: {
			fr: "Boite à outils",
			en: "Toolbox",
		},
		interests: {
			fr: "Intérêts",
			en: "Interests",
			list: {
				illustration: {
					fr: "Illustration",
					en: "Illustration"
				},
				games: {
					fr: "Jeux vidéo",
					en: "Video games"
				},
				lego: {
					fr: "Lego",
					en: "Lego"
				},
				music: {
					fr: "Musique",
					en: "Music"
				},
				cinema: {
					fr: "Cinéma",
					en: "Cinema"
				},
				photo: {
					fr: "Photo",
					en: "Photography"
				}
			}
		},
		skills: {
			fr: "Compétences",
			en: "Skills",
		},
		language: {
			fr: "Langues",
			en: "Languages",
			list: {
				fr: [
					{ name: "Français :", level: "Langue maternelle (C2)"},
					{ name: "Anglais :", level: "Courant professionnel (C1)" }
				],
				en: [
					{ name: "French:", level: "Proficient (C2)" },
					{ name: "English:", level: "Advanced (C1)" }
				]
			}
		},
		title: {
			fr: "Directeur artistique, UI/UX designer & illustrateur senior",
			en: "Senior Art Director, UI/UX Designer & Illustrator",
		},
		titlepro: {
			fr: "Parcours professionnel",
			en: "Professional experience",
		},
		titleedu: {
			fr: "Formation & études",
			en: "Education",
		},
		year: {
			fr: "ans",
			en: "years old",
		},
		experience: {
			fr: [
				{
					duration: "Depuis Août 2012",
					title: "Directeur artistique, UI/UX designer & illustrateur senior",
					subtitle: "P.Factory - Freelance",
					text: "J’accompagne les entreprises pour créer et développer leur marque en proposant une vision produit complète avec une large gamme d’expertises : branding, UI/UX design, création de site web et plus."
				},
				{
					duration: "Sept. 2014 - Juin 2024",
					title: "Directeur Artistique",
					subtitle: "dVine - CDI temps partiel",
					text: "Responsable de la direction artistique et du design produit de dVine pendant 10 ans : création du branding (logo, charte graphique, supports print, 3D) ainsi que l'UI/UX design de l'écosystème digital : design system, dashboards, app tablette, outil de génération PDF, e-shop et site vitrine."
				},
				{
					duration: "Oct. 2013 - Juil. 2015",
					title: "Directeur Artistique Junior",
					subtitle: "Nouvelles Conquêtes - CDI temps partiel",
					text: "Responsable de projets print et web au sein d’une petite équipe créative. Étroite collaboration avec le dirigeant, chefs de projets et équipe de développement. Conception de sites web (design + intégration), identités de marques, illustrations, intranets. Quelques clients : Schindler, Groupe Gambetta, K-bane."
				},
				{
					duration: "Août. 2012 - Déc. 2012",
					title: "Directeur Artistique Junior",
					subtitle: "Eluère et Associés - CDD",
					text: "Responsable de projets print et web au sein d’une équipe créative de 6 personnes. Étroite collaboration avec les chefs de publicité et directeurs conseil. Conception de brochures, identités de marques et sites web. Quelques clients : Brioche Dorée, VM Matériaux, IRM, Mismo."
				}
			],
			en: [
				{
					duration: "Since August 2012",
					title: "Senior Art Director,UI/UX Designer & Illustrator",
					subtitle: "P.Factory - Freelance",
					text: "As a master of many crafts, I help businesses create and elevate their brand by offering a complete product vision and a wide range of expertise: brand identity, UI/UX design, full website creation, and more."
				},
				{
					duration: "Sept. 2014 - June 2024",
					title: "Art Director",
					subtitle: "dVine - Part-time permanent contract",
					text: "Responsible for dVine's overall artistic direction and product design for 10 years: branding (logo, brand identity, prints, 3D) as well as UI/UX design for the digital ecosystem: design system, dashboards, tablet app, PDF generation tool, e-shop, and showcase website."
				},
				{
					duration: "Oct. 2013 - Jul. 2015",
					title: "Junior Art Director",
					subtitle: "Nouvelles Conquêtes - Part-time permanent contract",
					text: "Responsibilities include managing print and web projects within a small creative team. Collaborated closely with the manager, project managers, and development team. Responsibilities include website design (design and integration), brand identities, illustrations, and intranets. Clients include: Schindler, Groupe Gambetta, K-Bane."
				},
				{
					duration: "Aug. 2012 - Dec. 2012",
					title: "Junior Art Director",
					subtitle: "Eluère et Associés - Fixed-term contract",
					text: "Responsibilities include managing print and web projects within a creative team of six. Worked closely with advertising managers and consulting directors. Responsibilities included designing brochures, brand identities, and websites. Clients include: Brioche Dorée, VM Matériaux, IRM, Mismo."
				}
			]
		},
		education: {
			fr: [
				{
					duration: "Janv. 2013 - Juil. 2013",
					title: "Programme d'anglais intensif",
					subtitle: "City College of San Francisco",
					text: "Score TOEFL ITP : 580"
				},
				{
					duration: "2008 - 2012",
					title: "Formation graphisme & Design",
					subtitle: "École Brassart",
					text: "Licence de designer graphique et multimédia (Major)"
				},
				{
					duration: "2005 - 2008",
					title: "Baccalauréat",
					subtitle: "Lycée Saint Joseph du Loquidy",
					text: "Série Scientifique"
				}
			],
			en: [
				{
					duration: "Jan. 2013 - Jul. 2013",
					title: "Intensive English Program",
					subtitle: "City College of San Francisco",
					text: "TOEFL ITP Score: 580"
				},
				{
					duration: "2008 - 2012",
					title: "Graphic Design Program",
					subtitle: "Brassart School",
					text: "Bachelor’s degree in graphic and multimedia design, Graphic Arts"
				},
				{
					duration: "2005 - 2008",
					title: "Baccalaureate",
					subtitle: "Saint Joseph du Loquidy High School",
					text: "Physics"
				}
			]
		}
	},
};

const levelLabels = {
	1: { fr: "Notions", en: "Basic knowledge" },
	2: { fr: "Intermédiaire", en: "Intermediate" },
	3: { fr: "Expérimenté", en: "Experienced" },
	4: { fr: "Expert", en: "Expert" },
	5: { fr: "Ultra expert", en: "Ultra expert" },
};

text.levelLabels = levelLabels;

export default text;
